import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessagesSquare } from "lucide-react";
import { fetchSummary } from "../../services/CommApi";
import { connectComm, onComm, onCommStatus } from "../../services/commRealtime";
import { canOpen } from "../../permissions/registry";

/**
 * تحديث 59 — أيقونة مركز التواصل في الترويسة: عدد الرسائل غير المقروءة + التعاميم الجديدة/بانتظار الإقرار،
 * تتحدث فوراً عبر SignalR (وبالاستطلاع كل دقيقة عند غياب الاتصال الفوري).
 */
export function CommMenu() {
  // لا أيقونة لمن لا يعمل على مشروعات (موظف حضور فقط مثلاً)
  return canOpen("/communication") ? <CommMenuInner /> : null;
}

function CommMenuInner() {
  const navigate = useNavigate();
  const [s, setS] = useState(null);
  const [live, setLive] = useState(false);
  const load = useCallback(() => fetchSummary().then(setS).catch(() => {}), []);
  useEffect(() => {
    connectComm();
    load();
    let t; const soon = () => { clearTimeout(t); t = setTimeout(load, 600); };
    const offs = ["unread", "read", "circular", "rooms", "reconnected"].map((e) => onComm(e, soon));
    const offStatus = onCommStatus((st) => setLive(st === "live"));
    return () => { offs.forEach((o) => o()); offStatus(); clearTimeout(t); };
  }, [load]);
  useEffect(() => { if (live) return undefined; const p = setInterval(load, 60000); return () => clearInterval(p); }, [live, load]);
  const count = (s?.unreadMessages || 0) + (s?.unreadCirculars || 0) + (s?.pendingAck || 0);
  const title = s ? `مركز التواصل — ${s.unreadMessages} رسالة غير مقروءة · ${s.unreadCirculars} تعميم جديد · ${s.pendingAck} بانتظار الإقرار` : "مركز التواصل والتعاميم";
  return (
    <button type="button" className="ah-icon-btn" onClick={() => navigate(s?.pendingAck || s?.unreadCirculars ? "/communication?tab=circulars" : "/communication")}
      aria-label={title} title={title} data-testid="gh-comm">
      <MessagesSquare size={17} />
      {count > 0 && <span className="ah-badge" data-testid="gh-comm-badge">{count > 99 ? "99+" : count}</span>}
    </button>
  );
}
